import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Прямой URL бэкенда (если задан — запросы идут туда; иначе через proxy в dev)
if (process.env.REACT_APP_API_URL) {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;
}

// Firebase подгружаем асинхронно, чтобы не ломать приложение при ошибке
import('./firebase').catch(() => {});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
